import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import EnvironmentSwitcher from './components/EnvironmentSwitcher';
import config from './config';
import Dashboard from './pages/Dashboard';
import ProductSize from './pages/ProductSize';
import TrafficPoolList from './pages/trafficpool/TrafficPoolList';
import ProductInfo from './pages/ProductInfo';
import DataTemplate from './pages/DataTemplate';
import ProductType from './pages/ProductType';

import DataProcessing from './pages/DataProcessing';
import AIProviders from './pages/AIProviders';
import WebSocketTest from './pages/WebSocketTest';
import EANConfig from './pages/EANConfig';
import SKUConfig from './pages/SKUConfig';
import InventoryAmount from './pages/InventoryAmount';
import InventoryAmountLegacy from './pages/InventoryAmountLegacy';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import PromptGenerator from './pages/ai/PromptGenerator';
import TitleProcessing from './pages/TitleProcessing';

// 管理员相关组件
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import SimpleAdminLogin from './pages/admin/SimpleAdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserManagement from './pages/admin/UserManagement';
import AdminSettings from './pages/admin/AdminSettings';
import AdminTest from './pages/admin/AdminTest';
import ProcessingHistory from './pages/admin/ProcessingHistory';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* 用户端路由：所有业务页现在都需要先登录 */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/data-processing" element={<DataProcessing />} />
              <Route path="/websocket-test" element={<WebSocketTest />} />
              <Route path="/product-size" element={<ProductSize />} />
              <Route path="/traffic-pool" element={<TrafficPoolList />} />
              {/* 以下业务路由已迁移到后台管理，这里保留但可按需删除或重定向 */}
              {/* <Route path="/product-info" element={<ProductInfo />} /> */}
              {/* <Route path="/data-template" element={<DataTemplate />} /> */}
              {/* <Route path="/product-type" element={<ProductType />} /> */}
              {/* <Route path="/ai-providers" element={<AIProviders />} /> */}
              {/* <Route path="/ai-prompts" element={<PromptGenerator />} /> */}
              <Route path="/ean-config" element={<EANConfig />} />
              <Route path="/sku-config" element={<SKUConfig />} />
              <Route path="/inventory-amount" element={<InventoryAmount />} />
              <Route path="/inventory-amount-legacy" element={<InventoryAmountLegacy />} />
              {/* <Route path="/title-processing" element={<TitleProcessing />} /> */}
            </Route>

            {/* 管理员端路由 - 独立布局，不嵌套在用户Layout中 */}
            <Route path="/admin/test" element={<AdminTest />} />
            <Route path="/admin/login" element={<SimpleAdminLogin />} />
            <Route path="/admin/login-full" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="processing-history" element={<ProcessingHistory />} />
              <Route path="settings" element={<AdminSettings />} />
              {/* 迁移到后台管理下的页面，仅路由映射到相同组件 */}
              <Route path="product-info" element={<ProductInfo />} />
              <Route path="title-processing" element={<TitleProcessing />} />
              <Route path="data-template" element={<DataTemplate />} />
              <Route path="product-type" element={<ProductType />} />
              <Route path="ai-providers" element={<AIProviders />} />
              <Route path="ai-prompts" element={<PromptGenerator />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;